import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [
    { title: "不動産PF・企業金融 - 不動産投資・ファンド・資金調達の専門弁護士 | 法務法人フィサン" },
    { name: "description", content: "韓国ソウルの不動産PF・企業金融専門弁護士。不動産開発、プロジェクトファイナンス、不動産投資、資産運用、ファンド設立・運営、資金調達など総合的な法務支援を日本語で提供。" },
    { name: "keywords", content: "不動産PF, プロジェクトファイナンス, 不動産開発, 不動産投資, 企業金融, 資産運用, ファンド, 資金調達, 金融規制, 韓国弁護士, 日本語対応, ソウル法律事務所" },
    { property: "og:title", content: "不動産PF・企業金融 - 不動産投資・ファンド・資金調達の専門弁護士 | 法務法人フィサン" },
    { property: "og:description", content: "不動産プロジェクトファイナンス、企業金融、投資・資産運用の専門的な法律サービスを日本語で提供。日韓の法制度に精通した専門家が支援します。" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://jp-hwisang.co.kr/ja/services/real-estate-pf" },
    { property: "og:image", content: "https://jp-hwisang.co.kr/images/jp-hwisang-card.jpg" },
    { property: "og:locale", content: "ja_JP" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "robots", content: "index, follow" },
  ];
};

export default function RealEstatePFDetail() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <a href="/ja" className="flex items-center justify-center md:justify-start">
              <img src="/images/no-padding-logo.png" alt="法務法人フィサン" className="h-8 w-auto opacity-90" />
            </a>

            <div className="flex items-center justify-center md:justify-end gap-4 md:gap-6">
              <nav className="flex items-center gap-4 md:gap-6 text-sm">
                <a href="/ja/office" className="text-gray-700 hover:text-black whitespace-nowrap">事務所・所在地</a>
                <a href="/ja/services" className="text-black font-medium whitespace-nowrap">業務分野</a>
                <a href="/ja/blog" className="text-gray-700 hover:text-black whitespace-nowrap">法律ブログ</a>
              </nav>
              <a
                href="https://jp-hwisang.co.kr"
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-gray-300 hover:border-gray-900 text-gray-700 hover:text-black text-sm transition-colors whitespace-nowrap"
              >
                한국어
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Back Button */}
      <section className="py-8 px-4 border-b border-gray-200">
        <div className="max-w-4xl mx-auto">
          <a href="/ja/services" className="inline-flex items-center text-sm text-gray-600 hover:text-black transition-colors">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            業務分野一覧に戻る
          </a>
        </div>
      </section>

      {/* Title Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-serif mb-6 text-gray-900">企業金融及び不動産PF</h1>
          <div className="w-16 h-px bg-gray-400 mb-8"></div>
          <p className="text-xl text-gray-700 leading-relaxed">
            企業金融・不動産 PF ― 専門チームによる総合的なリーガルサービス
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-20 px-4">
        <div className="max-w-4xl mx-auto space-y-12">
          <div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              輝相（フィサン）は、企業金融および不動産 PFの分野において、豊富な実務経験と専門的知識をもとに、複雑な取引構造や法的課題に総合的なソリューションを提供します。
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              企業や投資家の皆様が安心して韓国で事業を展開できるよう、企画から実行、そして運用に至るまで一貫した法的支援を行います。
            </p>
          </div>

          <div className="border-t border-gray-200 pt-12">
            <h2 className="text-2xl font-serif mb-6 text-gray-900">不動産開発プロジェクトに関する総合的な法務支援</h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                輝相（フィサン）は、不動産開発事業における法的リスクの分析、契約構成、資金調達、許認可対応など、プロジェクトの全過程にわたって実践的なアドバイスを提供します。
              </p>
              <p>
                韓国の不動産市場特有の制度や規制に精通した弁護士が、開発事業を安全かつ効率的に進めるための最適な戦略を立案します。
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-12">
            <h2 className="text-2xl font-serif mb-6 text-gray-900">投資・資産運用・ファンド関連の法的サポート</h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                不動産投資・企業金融・資産運用の分野では、資産の流動化や私募ファンドの設立・運営など、高度な専門知識を必要とする案件が増えています。
              </p>
              <p>
                輝相（フィサン）の専門チームは、金融規制への対応から投資ストラクチャー設計、ファンド運営の法的枠組み構築まで、依頼者のニーズに合わせたワンストップリーガルサービスを提供します。
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-12">
            <h2 className="text-2xl font-serif mb-6 text-gray-900">日韓の法制度と投資環境を理解した専門家による支援</h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                日本企業・投資家が韓国で不動産投資やファイナンス事業を行う際には、両国の法制度・金融慣行・文化の違いを理解して対応することが不可欠です。
              </p>
              <p>
                輝相（フィサン）の弁護士は、日韓両国の法律と実務に精通し、信頼と透明性を重視した法的支援を通じて、お客様の事業と投資の成功を力強くサポートします。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            企業金融・不動産PFでお困りの方は、<br />お気軽にご相談ください。
          </p>
          <div className="space-y-4">
            <a href="tel:010-4729-3573" className="block text-gray-900 hover:text-gray-600 transition-colors">
              <p className="text-lg font-medium">010-4729-3573</p>
            </a>
            <a href="mailto:mgkim@hwisang.co.kr" className="block text-gray-900 hover:text-gray-600 transition-colors">
              <p className="text-lg font-medium">mgkim@hwisang.co.kr</p>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">法務法人フィサン</h5>
              <p className="text-sm text-gray-600 leading-relaxed">
                韓国を代表する法律事務所として、<br />
                専門的で信頼できる法律サービスを提供します
              </p>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">業務分野</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>刑事事件</li>
                <li>金融・不動産</li>
                <li>経営権紛争</li>
                <li>家事事件</li>
              </ul>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">お問い合わせ</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>電話: 010-4729-3573</li>
                <li>Email: mgkim@hwisang.co.kr</li>
                <li>住所: ソウル特別市江南区永東大路611, 13階</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-8 pt-8 text-center">
            <p className="text-xs text-gray-500">&copy; 2024 法務法人フィサン. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
